<h1 mat-dialog-title>{{ data.header }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick();">{{ data.cancel }}</button>
  <button mat-button (click)="okOnclick();" cdkFocusInitial>{{ data.accept }}</button>
</div>


<!-- Copyright 2019 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->